import React from 'react'
import './index.scss'
import logoPng from './img/logo.png'

const NavBar = (props) => {
    if (props.isJinRong) {
        return (<div className="NavBar">
            <div className="top-all">
                <div className="top-con clearfix">
                    <a className="tc-port" href="http://www.58.com" rel="noopener noreferrer" target="_blank">58同城首页</a>
                    <div className="right-con">
                        <span className="tel-line">客服热线</span>
                        <span>10105800</span>
                        <span>关注我们</span>
                        <a className="weixin-mo">
                            <i>
                                <img src="//jinrong.58.com/resources/static/img/weixin_icon.png" alt="微信公众号" />
                            </i>
                            <em className="jinrong-qr">
                                <img src="//jinrong.58.com/resources/static/img/jinrong-qr.png" alt="公众号二维码" />
                            </em>
                        </a>
                        <a href="//weibo.com/58jinrong" rel="noopener noreferrer" target="_blank">
                            <img src="//jinrong.58.com/resources/static/img/sina_icon.png" alt="58金融微博" />
                        </a>
                    </div>
                </div>
            </div>
            <div className="layout-header">
                <div className="header-con">
                    <a href="//jinrong.58.com/" rel="noopener noreferrer" target="_blank">
                        <img src="//j1.58cdn.com.cn/jinrong/logo_jinrong_pc.png" className="logo float-l" alt="58金融" />
                    </a>
                    <ul className="nav">
                        <li className="nav-item">
                            <a href="//jinrong.58.com/" rel="noopener noreferrer" target="_blank">首页</a>
                        </li>
                        <li className="nav-item">
                            <a href="//chefenqi.58.com/" rel="noopener noreferrer" target="_blank">58车分期</a>
                        </li>
                        <li className="nav-item">
                            <a href="//qiangui.58.com/help/58hb?from=58_PC" rel="noopener noreferrer" target="_blank" className="active">58钱柜</a>
                        </li>
                        <li className="nav-item">
                            <a href="//jinrong.58.com/k?from=wddk" rel="noopener noreferrer" target="_blank">现金贷款</a>
                        </li>
                        <li className="nav-item">
                            <a href="http://xyk.58.com/" rel="noopener noreferrer" target="_blank">信用卡</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>)
    } else {
        return (
            <div className="NavBar">
                <div className="head-m">
                    <img src={logoPng} title="58金融logo" className="logo" alt="58金融Logo" />
                    <div className="head-kefu fr tr">
                        <p className="f16">客服热线：10105800</p>
                        <p className="f12">周一到周日  9：00-18：00</p>
                    </div>
                </div>
            </div>
        )
    }

}

export default NavBar;


// WEBPACK FOOTER //
// ./src/components/NavBar/index.js